module.exports = jquery;